var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .st0{stroke:currentColor;stroke-width:115.1153;stroke-miterlimit:10}\n  "),React.createElement("path",{"className":"st0","fill":"currentColor","d":"M-.2 57.6l1000.2-.1M.8 395.6l1000.2-.1M.8 733.6l1000.2-.1","key":1})]);
}

Burger.defaultProps = {"version":"1.1","viewBox":"0 0 1000 791","xmlSpace":"preserve"};

module.exports = Burger;

Burger.default = Burger;
